import React from "react";

export function AutoCashOutToken() {
	return (
		<div className="autocashoutwrapper">
			<div className="cashoutbutton">
				<div className="textstackautobet">
					<div className="autocashtext">{"x 1.25"}</div>
					<div className="autocashlabel">{"AUTOCASHOUT"}</div>
				</div>
				<img
					className="iconrightautobet"
					loading="lazy"
					width="auto"
					height="auto"
					alt="__wf_reserved_inherit"
					src="https://uploads-ssl.webflow.com/650860e36a89f83f850ea0b9/65086c7059ebc8b20d906430_autoarrows.svg"
				/>
			</div>
		</div>
	);
}
